// import React, { useEffect, useState } from 'react'
// import {
//     Box,
//     Grid,
//     Typography,
//     TextField,
//     Button,
//     Checkbox,
//     FormControlLabel,
//     CircularProgress,
// } from '@mui/material'
// import axios from 'axios'
// import { useNavigate, useLocation } from 'react-router-dom'
// import apiUrl from '../../Config'

// const AddEditAuthors = () => {
//     const navigate = useNavigate()
//     const location = useLocation()
//     const [loading, setLoading] = useState(false)
//     // If navigating here to edit, author info is passed via location.state
//     const editingAuthor = location.state?.author || null

//     const [form, setForm] = useState({
//         name: '',
//         isActive: true,
//     })
//     const [imageFile, setImageFile] = useState(null)
//     const [preview, setPreview] = useState('')
//     const [mode, setMode] = useState('add')

//     useEffect(() => {
//         if (editingAuthor) {
//             setForm({
//                 name: editingAuthor.name || '',
//                 isActive: editingAuthor.isActive ?? false,
//             })
//             setPreview(editingAuthor.imageUrl || '')
//             setMode('edit')
//         }
//     }, [editingAuthor])

//     const handleChange = (e) => {
//         setForm({ ...form, [e.target.name]: e.target.value })
//     }

//     const handleCheckboxChange = (e) => {
//         setForm({ ...form, isActive: e.target.checked })
//     }

//     const handleFileChange = (e) => {
//         const file = e.target.files[0]
//         setImageFile(file)
//         setPreview(URL.createObjectURL(file))
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()
//         setLoading(true)
//         const formData = new FormData()
//         formData.append('name', form.name)
//         formData.append('isActive', form.isActive)
//         if (imageFile) formData.append('authorImage', imageFile)

//         try {
//             if (mode === 'edit' && editingAuthor) {
//                 await axios.put(`${apiUrl}/authors/updateauthor/${editingAuthor.id}`, formData)
//             } else {
//                 await axios.post(`${apiUrl}/authors/createauthor`, formData)
//             }
//             // After saving, go back to authors list page
//             navigate('/display-authors')
//         } catch (error) {
//             console.error('Error submitting form:', error)
//         } finally {
//             setLoading(false)
//         }
//     }

//     return (
//         <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }}>
//             <Typography variant="h3" mb={3}>
//                 {mode === 'edit' ? 'Edit Author' : 'Add Author'}
//             </Typography>

//             <Box
//                 component="form"
//                 onSubmit={handleSubmit}
//                 sx={{ maxWidth: 500, border: '1px solid lightgrey', padding: 2 }}
//             >
//                 <TextField
//                     fullWidth
//                     label="Author Name"
//                     name="name"
//                     value={form.name}
//                     onChange={handleChange}
//                     size="small"
//                     sx={{ mb: 3 }}
//                     required
//                 />

//                 <FormControlLabel
//                     control={
//                         <Checkbox
//                             checked={form.isActive}
//                             onChange={handleCheckboxChange}
//                             name="isActive"
//                         />
//                     }
//                     label="Active"
//                     sx={{ mb: 3 }}
//                 />

//                 <Button variant="outlined" component="label" fullWidth sx={{ mb: 3 }}>
//                     Upload Author Image
//                     <input
//                         type="file"
//                         hidden
//                         accept="image/*"
//                         onChange={handleFileChange}
//                     />
//                 </Button>

//                 {preview && (
//                     <Box mb={3} textAlign="center">
//                         <img
//                             src={preview}
//                             alt="Author Preview"
//                             style={{ maxWidth: '100%', maxHeight: 250, objectFit: 'contain' }}
//                         />
//                     </Box>
//                 )}

//                 <Box sx={{ display: 'flex', justifyContent: 'right', gap: 3 }}>
//                     <Button
//                         variant="outlined"
//                         onClick={() => {
//                             navigate('/display-authors')
//                             // window.history.back()
//                         }}
//                     >
//                         Cancel
//                     </Button>
//                     <Button type="submit" variant="contained" disabled={loading}
//                         startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}>
//                         {loading ? (mode === 'edit' ? 'Updating...' : 'Creating...') : (mode === 'edit' ? 'Update Author' : 'Create Author')}
//                     </Button>

//                 </Box>


//             </Box>
//         </Box>
//     )
// }

// export default AddEditAuthors


import React, { useEffect, useState } from 'react'
import {
    Box,
    Typography,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    CircularProgress,
} from '@mui/material'
import axios from 'axios'
import { useNavigate, useLocation } from 'react-router-dom'
import apiUrl from '../../Config'
import { toast } from 'react-toastify' // add toast import

const AddEditAuthors = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)
    // If navigating here to edit, author info is passed via location.state
    const editingAuthor = location.state?.author || null

    const [form, setForm] = useState({
        name: '',
        isActive: true,
    })
    const [imageFile, setImageFile] = useState(null)
    const [preview, setPreview] = useState('')
    const [mode, setMode] = useState('add')

    const [error, setError] = useState({
        name: '',
        submit: '',
    })

    useEffect(() => {
        if (editingAuthor) {
            setForm({
                name: editingAuthor.name || '',
                isActive: editingAuthor.isActive ?? false,
            })
            setPreview(editingAuthor.imageUrl || '')
            setMode('edit')
        }
    }, [editingAuthor])

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
        setError(prev => ({ ...prev, name: '', submit: '' })) // clear errors on change
    }

    const handleCheckboxChange = (e) => {
        setForm({ ...form, isActive: e.target.checked })
        setError(prev => ({ ...prev, submit: '' }))
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setImageFile(file)
        setPreview(URL.createObjectURL(file))
        setError(prev => ({ ...prev, submit: '' }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        // Validation
        if (!form.name.trim()) {
            setError(prev => ({ ...prev, name: 'Author name is required' }))
            return
        }

        setLoading(true)
        setError(prev => ({ ...prev, submit: '' }))

        const formData = new FormData()
        formData.append('name', form.name)
        formData.append('isActive', form.isActive)
        if (imageFile) formData.append('authorImage', imageFile)

        try {
            if (mode === 'edit' && editingAuthor) {
                await axios.put(`${apiUrl}/authors/updateauthor/${editingAuthor.id}`, formData)
                toast.success('Author updated successfully!')
            } else {
                await axios.post(`${apiUrl}/authors/createauthor`, formData)
                toast.success('Author created successfully!')
            }
            navigate('/display-authors')
        } catch (error) {
            console.error('Error submitting form:', error)
            const msg = error?.response?.data?.message || 'Something went wrong. Please try again.'
            setError(prev => ({ ...prev, submit: msg }))
            toast.error(msg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }}>
            <Typography variant="h3" mb={3}>
                {mode === 'edit' ? 'Edit Author' : 'Add Author'}
            </Typography>

            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ maxWidth: 500, border: '1px solid lightgrey', padding: 2 }}
            >
                <TextField
                    fullWidth
                    label="Author Name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    size="small"
                    sx={{ mb: 1 }}
                    error={!!error.name}
                    helperText={error.name}
                    disabled={loading}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={form.isActive}
                            onChange={handleCheckboxChange}
                            name="isActive"
                            disabled={loading}
                        />
                    }
                    label="Active"
                    sx={{ mb: 3 }}
                />

                <Button variant="outlined" component="label" fullWidth sx={{ mb: 3 }} disabled={loading}>
                    Upload Author Image
                    <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleFileChange}
                        disabled={loading}
                    />
                </Button>

                {preview && (
                    <Box mb={3} textAlign="center">
                        <img
                            src={preview}
                            alt="Author Preview"
                            style={{ maxWidth: '100%', maxHeight: 250, objectFit: 'contain' }}
                        />
                    </Box>
                )}

                {error.submit && (
                    <Typography color="error" mb={2}>
                        {error.submit}
                    </Typography>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'right', gap: 3 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            navigate('/display-authors')
                        }}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {loading
                            ? mode === 'edit'
                                ? 'Updating...'
                                : 'Creating...'
                            : mode === 'edit'
                                ? 'Update Author'
                                : 'Create Author'}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default AddEditAuthors
